import React from 'react';
import Chapter from '../components/Chapter';
import Text from '../components/Text';
import Video from '../components/Video';
import ogen from '../assets/ogen.mp4';

const Intro = ({
  id,
  trackEvent,
}) => (
  <Chapter
    theme="red"
    id={id}
    onEnter={() => trackEvent(id)}
  >
    <Text>Over twee jaar krijgt íedere Chinees een Social Credit Score van de overheid. Hoe voorbeeldiger je je gedraagt, hoe hoger je score. Hoe gaat dat?</Text>
    <Video src={ogen} />
    <Text light>Het is 2021. Jij bent Sui, 25 jaar en woont in Beijing. Net als voor 1,4 miljard andere Chinezen, is voor jou de Social Credit Score verplicht. Hieronder zie je hoe je week eruitziet. Speel het spel en houd je score in de gaten.</Text>
  </Chapter>
);

export default Intro;



// WEBPACK FOOTER //
// ./src/chapters/Intro.js